// breadcrumbUtils.ts
interface Breadcrumb {
    path: string;
    breadcrumb: React.ReactNode;
}

export const createBreadcrumbs = {
    // Breadcrumb apenas para Home
    home: (): Breadcrumb[] => [
        { path: '/', breadcrumb: '' }
    ],

    // Breadcrumb a partir da raiz
    fromRoot: (additionalBreadcrumbs: Breadcrumb[] = []): Breadcrumb[] => [
        { path: '/', breadcrumb: '' },
        ...additionalBreadcrumbs
    ],

    // Breadcrumb para páginas que vêm de Processos
    fromProcessos: (additionalBreadcrumbs: Breadcrumb[] = []): Breadcrumb[] => [
        { path: '/', breadcrumb: '' },
        { path: '/processos', breadcrumb: 'Processos' },
        ...additionalBreadcrumbs
    ],

    // Breadcrumb para páginas que não vêm de Processos (usuários sem permissão)
    withoutProcessos: (additionalBreadcrumbs: Breadcrumb[] = []): Breadcrumb[] => [
        { path: '/', breadcrumb: '' },
        ...additionalBreadcrumbs
    ]
};